import "./PopUp.css";
import closeBtn from "../../../image/CloseBlack.svg";

import Alert from '@mui/material/Alert';
import { useState } from "react";
import { apiFetch, readApiJson } from "../../../api/http";

const colors = [
    '#BD93E6',
    '#D3ACE3',
    '#F2A6D6',
    '#FF8F8F',
    '#F29E6F',
    '#FFD170',
    '#DCCD6A',
    '#9FC65F',
    '#95C5D3',
    '#99B2FE',
];

const FIELD_KEYS = [
    'parent_comment',
    'month_goals',
    'lesson_comment',
    'favorite_characters',
    'interests',
    'likes_dislikes',
];

function formatAssessmentDate(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        return '';
    }
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
}

function PopUp(props) {
    const { setDisplayPopUp, saveContext } = props;
    const [showAlert, setShowAlert] = useState({ succsess: false, fail: false });
    const [errorMessage, setErrorMessage] = useState('');
    const [saving, setSaving] = useState(false);

    function handleClose(e) {
        if (e.target.id === "popup") {
            setDisplayPopUp(prevState => ({ ...prevState, save: false }));
            document.body.style.overflow = 'auto';
        }
    }

    const showFail = (message) => {
        setErrorMessage(message || 'Ошибка при отправке');
        setShowAlert({ succsess: false, fail: true });
        setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, fail: false }));
        }, 4000);
    };

    const handleClick = () => {
        if (saving) return;

        const ctx = saveContext || {};
        const clientId = String(ctx.clientId || '').trim();
        const childId = String(ctx.childId || '').trim();
        const teacherName = String(ctx.teacherName || '').trim();
        const birthDate = String(ctx.criterionRequestParam?.dateBirthValue || '').trim();
        const birthDateName = String(ctx.criterionRequestParam?.dateBirthName || '').trim();
        const subject = ctx.lessonName;
        const subjectValue = subject?.value;
        const subjectName = subject?.name;

        if (!clientId || !childId) {
            showFail('Необходимо выбрать ребенка из списка в поле «Ребёнок». При возникновении трудностей обратитесь в техподдержку.');
            return;
        }
        if (!teacherName) {
            showFail('Укажите имя педагога');
            return;
        }
        if (!birthDate || birthDate === 'null') {
            showFail('Выберите возраст ребёнка');
            return;
        }
        if (!subjectName || subjectName === 'Не выбрано' || !subjectValue) {
            showFail('Выберите направление');
            return;
        }

        const inputData = ctx.inputData || {};
        const fields = FIELD_KEYS.map((key) => ({ [key]: inputData[key] ?? '' }));

        const values = ctx.studentParametersValues || {};
        const perfomance = Object.keys(values).map((key, index) => ({
            [key]: [String(values[key] ?? 0), colors[index % colors.length]],
        }));

        const payload = {
            client_id: clientId,
            child_id: childId,
            child_name: ctx.childName || '',
            teacher_id: ctx.teacherId || null,
            teacher_name: teacherName,
            birth_date: birthDate,
            birth_date_name: birthDateName,
            subject: { value: subjectValue, name: subjectName },
            assessment_date: formatAssessmentDate(ctx.assessmentDate),
            fields,
            perfomance,
        };

        setSaving(true);
        apiFetch("/sendChild", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((res) => readApiJson(res))
            .then(({ ok, body, message }) => {
                if (ok && body?.success) {
                    setShowAlert({ succsess: true, fail: false });
                    setTimeout(() => {
                        setShowAlert((prev) => ({ ...prev, succsess: false }));
                        setDisplayPopUp((prev) => ({ ...prev, save: false }));
                        document.body.style.overflow = 'auto';
                    }, 3000);
                    return;
                }
                showFail(message || body?.description || body?.show_text || 'Ошибка при отправке');
            })
            .catch(() => {
                showFail('Сетевая ошибка при сохранении');
            })
            .finally(() => {
                setSaving(false);
            });
    };

    return (
        <div className="popup" id="popup" onClick={(e) => handleClose(e)}>
            <Alert severity="success" sx={{
                position: "absolute",
                top: "0",
                transition: "opacity 0.5s ease-in-out",
                opacity: showAlert.succsess ? 1 : 0,
            }}>Успешно отправлено</Alert>

            <Alert severity="error" sx={{
                position: "absolute",
                top: "0",
                transition: "opacity 0.5s ease-in-out",
                opacity: showAlert.fail ? 1 : 0,
            }}>Ошибка при отправке: {errorMessage}</Alert>

            <div className="popup-content">
                <div className="popup-close-button">
                    <img src={closeBtn} alt="closeBtn" onClick={() => { setDisplayPopUp(prevState => ({ ...prevState, save: false })); document.body.style.overflow = 'auto'; }} />
                </div>
                <p>Сохранить текущую версию колеса баланса?</p>
                <button onClick={handleClick} disabled={saving}>{saving ? 'Сохранение…' : 'Сохранить'}</button>
                <button className="back-to-edit" onClick={() => { setDisplayPopUp(prevState => ({ ...prevState, save: false })); document.body.style.overflow = 'auto'; }}>Нет, вернуться к редактированию</button>
            </div>
        </div>
    );
}

export default PopUp;
